import { FC } from "react";

export const ProjectIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0007 8.63379H5.33398C5.06065 8.63379 4.83398 8.40712 4.83398 8.13379C4.83398 7.86046 5.06065 7.63379 5.33398 7.63379H10.0007C10.274 7.63379 10.5007 7.86046 10.5007 8.13379C10.5007 8.40712 10.274 8.63379 10.0007 8.63379Z"
  
    />
    <path
      d="M8.25398 11.2998H5.33398C5.06065 11.2998 4.83398 11.0731 4.83398 10.7998C4.83398 10.5265 5.06065 10.2998 5.33398 10.2998H8.25398C8.52732 10.2998 8.75398 10.5265 8.75398 10.7998C8.75398 11.0731 8.52732 11.2998 8.25398 11.2998Z"
   
    />
    <path
      d="M9.33398 4.49967H6.66732C6.02732 4.49967 4.83398 4.49967 4.83398 2.66634C4.83398 0.833008 6.02732 0.833008 6.66732 0.833008H9.33398C9.97398 0.833008 11.1673 0.833008 11.1673 2.66634C11.1673 3.30634 11.1673 4.49967 9.33398 4.49967ZM6.66732 1.83301C6.00732 1.83301 5.83398 1.83301 5.83398 2.66634C5.83398 3.49967 6.00732 3.49967 6.66732 3.49967H9.33398C10.1673 3.49967 10.1673 3.32634 10.1673 2.66634C10.1673 1.83301 9.99398 1.83301 9.33398 1.83301H6.66732Z"
 
    />
    <path
      d="M10 15.1669H6C2.25333 15.1669 1.5 13.4469 1.5 10.6669V6.66695C1.5 3.62695 2.6 2.32695 5.30667 2.18695C5.57333 2.17361 5.82 2.38028 5.83333 2.66028C5.84667 2.94028 5.63333 3.16695 5.36 3.18028C3.46667 3.28695 2.5 3.85361 2.5 6.66695V10.6669C2.5 13.1336 2.98667 14.1669 6 14.1669H10C13.0133 14.1669 13.5 13.1336 13.5 10.6669V6.66695C13.5 3.85361 12.5333 3.28695 10.64 3.18028C10.3667 3.16695 10.1533 2.92695 10.1667 2.65361C10.18 2.38028 10.42 2.16695 10.6933 2.18028C13.4 2.32695 14.5 3.62695 14.5 6.66028V10.6603C14.5 13.4469 13.7467 15.1669 10 15.1669Z"
  
    />
  </svg>
);
